import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
// Icons
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';

const drawerWidth = 240;

function Sidebar() {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex'}}>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            display: 'flex', // Enable flex container
            flexDirection: 'column', // Stack child elements vertically
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '25px',
            marginTop:'20px'
          }}
        >
          <Card sx={{ maxWidth: 80, borderRadius: '10px' }}>
            <CardMedia
              component="img"
              image="/logo.png" // Adjust the path as necessary
              sx={{ width: 80, height: 80 }}
            />
          </Card>
        </Box>
        <Box sx={{ p: 2, flex: 1 }}> {/* Allow this box to expand */}
          <List>
            {[
              { text: 'Home', path: '/home', Icon: HomeRoundedIcon },
              { text: 'Designs', path: '/designs', Icon: AutoFixHighRoundedIcon },
              { text: 'Saved', path: '/saved', Icon: BookmarkRoundedIcon}
            ].map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  sx={{
                    p: 1,
                    borderRadius: '10px',
                    marginBottom: '5px',
                    backgroundColor: location.pathname === item.path ? '#ff4c15ff' : 'transparent',
                    color: location.pathname === item.path ? '#FFFFFF' : 'inherit',
                    '&:hover': {
                      backgroundColor: location.pathname !== item.path ? '#e0e0e0' : '#ff4c15ff',
                      color: location.pathname !== item.path ? '#000000' : '#FFFFFF',
                    },
                    '.MuiListItemIcon-root': {
                      color: location.pathname === item.path ? '#FFFFFF' : 'inherit',
                    },
                    '.MuiListItemText-primary': {
                      color: location.pathname === item.path ? '#FFFFFF' : 'inherit',
                    }
                  }}
                >
                  <ListItemIcon>
                    <item.Icon />
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        <Box sx={{ p: 2 }}> {/* Settings box */}
          <List>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/settings"
                sx={{
                  p: 1,
                  borderRadius: '10px',
                  backgroundColor: location.pathname === "/settings" ? '#ff4c15ff' : 'transparent',
                  color: location.pathname === "/settings" ? '#FFFFFF' : 'inherit',
                  '&:hover': {
                    backgroundColor: location.pathname !== "/settings" ? '#e0e0e0' : '#ff4c15ff',
                    color: location.pathname !== "/settings" ? '#000000' : '#FFFFFF',
                  },
                  '.MuiListItemIcon-root': {
                    color: location.pathname === "/settings" ? '#FFFFFF' : 'inherit',
                  },
                  '.MuiListItemText-primary': {
                    color: location.pathname === "/settings" ? '#FFFFFF' : 'inherit',
                  }
                }}
              >
                <ListItemIcon>
                  <ManageAccountsRoundedIcon />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Sidebar;
